import { css } from '@linaria/core';
export const styles = {
  button: "omponents__ShareButton__styles_ts-button-btqneyd"
};

require("./styles.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./styles.ts");